import { color } from '@starryui10/theme/color';
import React from 'react';

export const SearchEntry = () => {
    return (
        <svg width="96" height="96" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="48" cy="48" r="48" fill={color.Grey.G10} />
            <circle cx="41.5" cy="42.5" r="21.5" fill="white" />
            <g filter="url(#filter0_d)">
                <path
                    d="M63.2376 62.5255L59.4316 58.7195M64.2579 43.129C64.2579 55.3491 54.3491 65.2579 42.129 65.2579C29.9089 65.2579 20 55.3491 20 43.129C20 30.9089 29.9089 21 42.129 21C54.3491 21 64.2579 30.9089 64.2579 43.129ZM71.1495 74.4534L63.1237 66.4277C62.0069 65.3109 62.0069 63.5126 63.1237 62.4147C64.2216 61.2979 66.0199 61.2979 67.1367 62.4147L75.1624 70.4404C76.2793 71.5573 76.2793 73.3555 75.1624 74.4534C74.0646 75.5702 72.2663 75.5702 71.1495 74.4534Z"
                    stroke={color.Blue.B60}
                    strokeWidth="2"
                    strokeMiterlimit="10"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
            <path
                d="M50.5 41.1538C50.5 46.7605 47.7164 51.3077 42.25 51.3077C36.7836 51.3077 34 46.7605 34 41.1538C34 35.5472 36.7836 31 42.25 31C47.7164 31 50.5 35.5472 50.5 41.1538Z"
                fill={color.Grey.G10}
            />
            <path
                d="M27.9097 59.7544C30.2633 56.9191 33.8348 55.1104 37.8334 55.1104H45.1667C49.4641 55.1104 53.2682 57.1995 55.5973 60.4067C51.9407 63.4354 47.2472 65.2559 42.129 65.2559C36.6533 65.2559 31.6636 63.1721 27.9097 59.7544Z"
                fill={color.Grey.G10}
            />
            <path
                d="M50.5 41.1538C50.5 46.7605 47.7164 51.3077 42.25 51.3077C36.7836 51.3077 34 46.7605 34 41.1538C34 35.5472 36.7836 31 42.25 31C47.7164 31 50.5 35.5472 50.5 41.1538Z"
                stroke={color.Blue.B60}
                strokeWidth="2"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M27.9097 59.7544C30.2633 56.9191 33.8348 55.1104 37.8334 55.1104H45.1667C49.4641 55.1104 53.2682 57.1995 55.5973 60.4067C51.9407 63.4354 47.2472 65.2559 42.129 65.2559C36.6533 65.2559 31.6636 63.1721 27.9097 59.7544Z"
                stroke={color.Blue.B60}
                strokeWidth="2"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <defs>
                <filter id="filter0_d" x="14" y="17" width="68" height="66.291" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                    <feOffset dy="2" />
                    <feGaussianBlur stdDeviation="2.5" />
                    <feColorMatrix type="matrix" values="0 0 0 0 0.152941 0 0 0 0 0.156863 0 0 0 0 0.2 0 0 0 0.2 0" />
                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
                </filter>
            </defs>
        </svg>
    );
};
